// @flow
import React, { Component } from 'react';
import { type Currency, type Currencies } from '../../../utilities/types';
import {
  Desktop,
  Default,
  Mobile,
  LgDesktop
} from '../../../components/Responsive';
import { formatCurrency } from '../../../utilities/numberFormatting';
import DefaultModelRowTr from '../../../modules/CrudTable/components/DefaultModelRowTr';
import {
  CustomModelListTd,
  SubtitleP,
  TableRowAlignmentDiv
} from '../../../modules/CrudTable/CrudTableStyles';
import { formatDate } from '../../../utilities/misc';

type Props = {
  data: {
    total_fees_usd: number,
    total_merchants: number,
    total_processing_vol_usd: number,
    company_name: string,
    email: string,
    id: number,
    created_at: string
  },
  tableBodyOptions: {
    partnerCurrency: Currency,
    handleShow: Function,
    currencies: Currencies
  },
  index: number
};
export default class TableRow extends Component<Props> {
  handleTableDetail = () => {
    this.props.tableBodyOptions.handleShow(this.props.data.id);
  };

  render() {
    return (
      <DefaultModelRowTr
        key={this.props.index}
        onClick={this.handleTableDetail}
        hoverStylesMobile
        hoverStyles
      >
        <CustomModelListTd bold>
          {this.props.data.company_name}
          <Default>
            <SubtitleP color="dustierGray">{this.props.data.email}</SubtitleP>
          </Default>
          <Mobile>
            <SubtitleP color="blue">
              {this.props.data.total_merchants} merchants
            </SubtitleP>
          </Mobile>
        </CustomModelListTd>
        <LgDesktop>
          <CustomModelListTd>
            {formatDate(this.props.data.created_at)}
          </CustomModelListTd>
        </LgDesktop>
        <Default>
          <CustomModelListTd right>
            <Default>
              <TableRowAlignmentDiv />
            </Default>
            {this.props.data.total_merchants}
          </CustomModelListTd>
        </Default>
        <CustomModelListTd right>
          <Default>
            <TableRowAlignmentDiv />
          </Default>
          {formatCurrency(
            this.props.data.total_processing_vol_usd,
            this.props.tableBodyOptions.currencies['USD']
          )}
          <Mobile>
            <SubtitleP color="dustierGray">
              Fees:{' '}
              {formatCurrency(
                this.props.data.total_fees_usd,
                this.props.tableBodyOptions.currencies['USD']
              )}
            </SubtitleP>
          </Mobile>
        </CustomModelListTd>
        <Desktop>
          <CustomModelListTd right>
            <Default>
              <TableRowAlignmentDiv />
            </Default>
            {formatCurrency(
              this.props.data.total_fees_usd,
              this.props.tableBodyOptions.currencies['USD']
            )}
          </CustomModelListTd>
        </Desktop>
      </DefaultModelRowTr>
    );
  }
}
